export const CloverAuthorizationMode = {
    OAUTH: 'oauth',
    OAUTH_GRANT_BINDING: 'oauth_grant_binding',
} as const;

export type CloverAuthorizationMode =
    (typeof CloverAuthorizationMode)[keyof typeof CloverAuthorizationMode];

export interface CloverOAuthCredentialsPublic {
    merchantId: string;
}

export interface CloverOAuthCredentialsSecret {
    accessToken: string;
}

export type CloverOAuthCredentialsPublicFields = 'merchantId';
export type CloverOAuthCredentialsSecretFields = 'accessToken';
export type CloverOAuthCredentialsAllFields =
    | CloverOAuthCredentialsPublicFields
    | CloverOAuthCredentialsSecretFields;

export interface CloverOAuthCredentials
    extends CloverOAuthCredentialsPublic, CloverOAuthCredentialsSecret {}

export interface DraftCloverOAuthCredentials {
    merchantId?: string;
    accessToken?: string;
}

export interface CloverOAuthGrantBindingCredentials {
    merchantId: string;
}

export interface DraftCloverOAuthGrantBindingCredentials {
    merchantId?: string;
}

export interface CloverPersistedOAuthCredentialsV2Manual {
    credential_payload_version: 2;
    authorization_source: 'manual';
    merchantId: string;
    accessToken: string;
}

export interface CloverPersistedOAuthCredentialsV2GrantBinding {
    credential_payload_version: 2;
    authorization_source: 'grant';
    merchantId: string;
}

export type CloverPersistedOAuthCredentialsV2 =
    | CloverPersistedOAuthCredentialsV2Manual
    | CloverPersistedOAuthCredentialsV2GrantBinding;

export type CloverStoredOAuthCredentials =
    | CloverOAuthCredentials
    | CloverPersistedOAuthCredentialsV2;

export type DraftCloverCredentials = DraftCloverOAuthCredentials;

export interface CloverResolvedOAuthCredentials extends CloverOAuthCredentials {
    authorizationMode: typeof CloverAuthorizationMode.OAUTH;
}

export interface CloverResolvedOAuthGrantBindingCredentials extends CloverOAuthGrantBindingCredentials {
    authorizationMode: typeof CloverAuthorizationMode.OAUTH_GRANT_BINDING;
}

export type CloverResolvedCredentials =
    | CloverResolvedOAuthCredentials
    | CloverResolvedOAuthGrantBindingCredentials;

export type CloverCredentials = CloverResolvedCredentials;
